module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码加工作人员好友，进入培训微信群")]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("场次信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.danwei))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "场次："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.station_name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.station.startdate + '至' + _vm.row.station.enddate))])])], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("个人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市区："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.province + '  ' + _vm.row.city + ' ' + _vm.row.county + ' ' + _vm.row.address))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.member.name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.member.num))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号："
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.row.member.phone))])])], 1)], 1), _vm._v(" "), (_vm.row.cert_url && _vm.row.cert_url.url) ? _c('div', {
    staticClass: "cert-li"
  }, [_c('el-divider', [_vm._v("结业证书")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row.cert_url.url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cert-button"
  }, [_c('el-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.appDownload(_vm.row.cert_url.filename, _vm.row.cert_url.url)
      }
    }
  }, [_vm._v("点击下载\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("资料信息")]), _vm._v(" "), _c('el-row', _vm._l((_vm.row.goods_list), function(goods, index) {
    return _c('el-col', {
      key: _vm.inedx,
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": goods.item_title
      }
    }, [_c('div', [_vm._v(_vm._s(goods.count + '' + goods.unit + ' '))])])], 1)
  }), 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [(_vm.row.next_gjsb) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiApplyFormStep3',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'SongpeiApplyFormStep3' ,query:{ id:row.id }}"
    }],
    attrs: {
      "round": ""
    }
  }, [_vm._v("资质申报\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.toStep2
    }
  }, [_vm._v("资料订购\n          ")]), _vm._v(" "), (_vm.row.station.can_exame == 1) ? _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiExame',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'SongpeiExame' ,query:{ id:row.id }}"
    }],
    attrs: {
      "round": ""
    }
  }, [_vm._v("在线考试\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiApplyList'
      }),
      expression: "{name:'SongpeiApplyList'}"
    }],
    attrs: {
      "type": "primary",
      "round": ""
    }
  }, [_vm._v("我的报名记录\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76fd8732","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/songpei/SongpeiApplyFormSuccess.vue
// module id = 1489
// module chunks = 0